import { acceptClientRequest, rejectClientRequest } from '../vendor/asyncThunks';
import { fetchNumOfUnreadNotifications, getAllNotifications, markNotificationsAsSeen } from './asyncThunks';
import { NOTIFICATION_STATUS, NOTIFICATION_TYPE, PAYMENT_STATUS } from '../../../utils/constants';
import { acceptClientAppointment, rejectClientAppointment } from '../appointment/asyncThunks';
import { acceptClientPayment, rejectPaymentForClient } from '../payment/asyncThunks';
import { acceptClientDeleteRequest, rejectContractDeleteRequest } from '../wedding/asyncThunks';

export const getAllNotificationsBuilder = builder => {
  builder.addCase(getAllNotifications.pending, state => {
    state.getAllNotificationsPending = true;
  });
  builder.addCase(getAllNotifications.fulfilled, (state, { payload }) => {
    const { data, maxReached, page, total, perPage } = payload;

    state.notifications.data = data;
    state.notifications.maxReached = maxReached;
    state.notifications.page = page;
    state.notifications.total = total;
    state.notifications.perPage = perPage;

    state.getAllNotificationsPending = false;
  });
  builder.addCase(getAllNotifications.rejected, state => {
    state.getAllNotificationsPending = false;
  });
};

export const fetchNumOfUnReadNotificationsBuilder = builder => {
  builder.addCase(fetchNumOfUnreadNotifications.pending, state => {});
  builder.addCase(fetchNumOfUnreadNotifications.fulfilled, (state, { payload }) => {
    state.numOfUnreadNotifications = payload;
  });
  builder.addCase(fetchNumOfUnreadNotifications.rejected, state => {});
};

export const markNotificationsAsSeenBuilder = builder => {
  builder.addCase(markNotificationsAsSeen.pending, state => {});
  builder.addCase(markNotificationsAsSeen.fulfilled, (state, { payload }) => {
    state.numOfUnreadNotifications = 0;
  });
  builder.addCase(markNotificationsAsSeen.rejected, state => {});
};

export const acceptClientRequestBuilder = builder => {
  builder.addCase(acceptClientRequest.pending, state => {
    state.acceptClientRequestPending = true;
  });
  builder.addCase(acceptClientRequest.fulfilled, (state, { payload }) => {
    const { notificationId } = payload;
    state.notifications.data = state.notifications.data.map(notification => {
      if (notification.id === notificationId) {
        notification.data.status = NOTIFICATION_STATUS.ACCEPTED;
      }
      return notification;
    });
    state.acceptClientRequestPending = false;
  });
  builder.addCase(acceptClientRequest.rejected, state => {
    state.acceptClientRequestPending = false;
  });
};

export const rejectClientRequestBuilder = builder => {
  builder.addCase(rejectClientRequest.pending, state => {
    state.rejectClientRequestPending = true;
  });
  builder.addCase(rejectClientRequest.fulfilled, (state, { payload }) => {
    const { notificationId } = payload;
    state.notifications.data = state.notifications.data.map(notification => {
      if (notification.id === notificationId) {
        notification.data.status = NOTIFICATION_STATUS.REJECTED;
      }
      return notification;
    });
    state.rejectClientRequestPending = false;
  });
  builder.addCase(rejectClientRequest.rejected, state => {
    state.rejectClientRequestPending = false;
  });
};

export const acceptClientPaymentRequestBuilder = builder => {
  builder.addCase(acceptClientPayment.fulfilled, (state, { payload }) => {
    const { notificationId, paymentId } = payload;

    if (notificationId) {
      state.notifications.data = state.notifications.data.map(notification => {
        if (notification.id === notificationId) {
          notification.data = { ...notification.data, status: PAYMENT_STATUS.APPROVED };
        }
        return notification;
      });
    } else {
      state.notifications.data = state.notifications.data.map(notification => {
        if (
          notification.type === NOTIFICATION_TYPE.PAYMENT_CREATED &&
          notification.data.paymentId === paymentId &&
          notification.data.status === PAYMENT_STATUS.PENDING
        ) {
          notification.data = { ...notification.data, status: PAYMENT_STATUS.APPROVED };
        }
        return notification;
      });
    }
  });
};

export const acceptClientAppointmentRequestBuilder = builder => {
  builder.addCase(acceptClientAppointment.pending, state => {});
  builder.addCase(acceptClientAppointment.fulfilled, (state, { payload }) => {
    const { notificationId } = payload;
    state.notifications.data = state.notifications.data.map(notification => {
      if (notification.id === notificationId) {
        notification.data.status = NOTIFICATION_STATUS.ACCEPTED;
      }
      return notification;
    });
  });
  builder.addCase(acceptClientAppointment.rejected, state => {});
};

export const rejectPaymentForClientRequestBuilder = builder => {
  builder.addCase(rejectPaymentForClient.fulfilled, (state, { payload }) => {
    const { notificationId } = payload;
    state.notifications.data = state.notifications.data.map(notification => {
      if (notification.id === notificationId) {
        notification.data.status = NOTIFICATION_STATUS.REJECTED;
      }
      return notification;
    });
  });
};

export const rejectClientAppointmentRequestBuilder = builder => {
  builder.addCase(rejectClientAppointment.fulfilled, (state, { payload }) => {
    const { notificationId } = payload;
    state.notifications.data = state.notifications.data.map(notification => {
      if (notification.id === notificationId) {
        notification.data.status = NOTIFICATION_STATUS.REJECTED;
      }
      return notification;
    });
  });
};

export const acceptClientDeleteRequestBuilder = builder => {
  builder.addCase(acceptClientDeleteRequest.fulfilled, (state, { payload }) => {
    const { notificationId } = payload;
    state.notifications.data = state.notifications.data.map(notification => {
      if (notification.id === notificationId) {
        notification.data.status = NOTIFICATION_STATUS.ACCEPTED;
      }
      return notification;
    });
  });
};

export const rejectContractDeleteRequestBuilder = builder => {
  builder.addCase(rejectContractDeleteRequest.fulfilled, (state, { payload }) => {
    const { notificationId } = payload;
    state.notifications.data = state.notifications.data.map(notification => {
      if (notification.id === notificationId) {
        notification.data.status = NOTIFICATION_STATUS.REJECTED;
      }
      return notification;
    });
  });
};
